export default "__VITE_ASSET__gR4nTpG___"